<template>
  <ion-page>
    <ion-content>
      <div class="meeting-end-container">
        <!--   評分頁面     -->
        <FeedbackForm v-if="!feedbackSubmitted"
                      @submit="onFeedbackSubmitted" />
        <!--   評分完成頁面     -->
        <FeedbackConfirmation v-else />
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import FeedbackForm from '../components/MeetingEnd/FeedbackForm.vue'
import FeedbackConfirmation from '../components/MeetingEnd/FeedbackConfirmation.vue'

export default defineComponent({
  name: 'MeetingEndPage',
  components: { FeedbackConfirmation, FeedbackForm },
  data() {
    return {
      // 是否已提交評分
      feedbackSubmitted: false,
      // 評分值
      feedbackRating: 0,
    }
  },
  methods: {
    /**
     * 處理評分提交
     * @param rating {number} 評分值
     * @return {void}
     */
    onFeedbackSubmitted(rating: number): void {
      // 設置評分值
      this.feedbackRating = rating
      // 設置已提交評分
      this.feedbackSubmitted = true

      // 這裡可以添加 API 調用以保存評分
      console.log(`Feedback submitted with rating: ${rating}`)
    },
  },
})
</script>

<style lang="scss" scoped>
.meeting-end-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 16px;
}
</style>
